export default __webpack_public_path__ + "static/media/ill-2.b82bc41c.svg";